import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CATEGORIES = [
  { key: 'одежда', name: 'Одежда', icon: '👕' },
  { key: 'обувь', name: 'Обувь', icon: '👟' },
  { key: 'аксессуары', name: 'Аксессуары', icon: '👜' },
];

const SUBCATEGORIES = {
  одежда: ['Анораки','Бермуды','Блузки','Блузки-боди','Болеро','Бомберы','Бриджи','Брюки','Велосипедки','Ветровки','Водолазки','Дафлкоты','Джеггинсы','Джемперы','Джинсы','Дождевики','Дубленки','Жакеты','Жилеты','Капри','Кардиганы','Карнавальные костюмы','Кейпы','Кигуруми','Килты банные','Комбинезоны','Косухи','Костюмы','Кофты','Крестильные комплекты','Куртки','Леггинсы','Лонгсливы','Мантии','Ночные сорочки','Пальто','Парки','Пеньюары','Пиджаки','Пижамы','Платья','Плащи','Полукомбинезоны','Полупальто','Пончо','Пуловеры','Пуховики','Рубашки','Сарафаны','Свитеры','Свитшоты','Твинсеты','Толстовки','Топы','Тренчкоты','Туники','Футболки','Футболки-поло','Халаты банные','Халаты домашние','Худи','Шорты','Шубы искусственные','Шубы натуральные','Юбки'].sort(),
  обувь: ['Балетки','Босоножки','Ботильоны','Ботинки','Ботфорты','Валенки','Галоши','Дутики','Кеды','Кроссовки','Лоферы','Луноходы','Мокасины','Мюли','Полуботинки','Полусапожки','Резиновые сапоги','Сабо','Сандалии','Сапоги','Слипоны','Сноубутсы','Тапочки','Туфли','Угги','Унты','Шлепанцы','Эспадрильи'].sort(),
  аксессуары: ['Багажные бирки','Банданы','Бабочки','Браслеты для часов','Веера','Визитницы','Воротники','Галстуки','Горжетки','Декор для одежды','Декор для сумок и рюкзаков','Держатели для очков','Зажимы для денег','Зеркальца','Зонты','Имиджевые очки','Инструменты и запчасти для часов','Клатчи','Клипсы и расширители для пояса','Ключницы','Косметички','Косточки для воротника рубашки','Кошельки','Кредитницы','Манжеты','Манишки','Маски для сна','Митенки','Монетницы','Муфты для рук','Накладные плечи','Носовые платки','Обложки','Обложки для документов','Органайзеры для сумки','Палантины','Парео','Перчатки','Платки','Подворотнички одноразовые','Подкладки для сумок','Подтяжки','Портфели','Портупеи','Пояса','Пряжки','Ремни','Ремни для сумок','Ремни для часов','Ручки для сумок','Рюкзаки','Снуды','Солнцезащитные очки','Сумки','Сумки-тележки','Сумки хозяйственные','Сумки-шопперы','Темляки','Фата','Фиксаторы для очков','Формодержатели для сумок','Фурнитура для чемоданов','Футляры для очков','Цепочки для очков','Часы карманные','Часы наручные','Часы-кулон','Чемоданы','Чехлы для сумок и рюкзаков','Чехлы для чемоданов','Шали','Шапки для сна','Шарфы','Шарфы-пледы','Шнурки для очков','Штрипки для брюк'].sort()
};

function CategoriesPageMobile() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();

  const handleCategoryClick = (catKey) => {
    setSelectedCategory(catKey);
  };

  const handleSubcategoryClick = (subcat) => {
    const params = new URLSearchParams();
    if (selectedCategory) params.set('category', selectedCategory);
    params.set('subcategory', subcat);
    navigate(`/?${params.toString()}`);
  };

  const handleBack = () => {
    setSelectedCategory(null);
  };

  const subcategories = selectedCategory ? SUBCATEGORIES[selectedCategory] || [] : [];

  return (
    <div style={{ padding: '16px 12px', background: '#f8fafc', minHeight: '100vh' }}>
      {/* Заголовок с кнопкой назад (если выбрана категория) */}
      {selectedCategory ? (
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
          <button
            onClick={handleBack}
            style={{ background: 'none', border: 'none', fontSize: 20, marginRight: 12, cursor: 'pointer', color: '#7C3AED' }}
          >
            ←
          </button>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#1e293b', margin: 0 }}>
            {CATEGORIES.find(c => c.key === selectedCategory)?.name}
          </h2>
        </div>
      ) : (
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#1e293b', marginBottom: 20 }}>Категории</h2>
      )}

      {!selectedCategory ? (
        // Сетка из трёх категорий
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {CATEGORIES.map(cat => (
            <div
              key={cat.key}
              onClick={() => handleCategoryClick(cat.key)}
              style={{
                background: 'white',
                borderRadius: 12,
                padding: 20,
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                cursor: 'pointer',
                transition: 'transform 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.02)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
            >
              <span style={{ fontSize: 36 }}>{cat.icon}</span>
              <div>
                <div style={{ fontSize: 18, fontWeight: 600, color: '#1e293b' }}>{cat.name}</div>
                <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>
                  {SUBCATEGORIES[cat.key]?.length || 0} подкатегорий
                </div>
              </div>
              <div style={{ marginLeft: 'auto', color: '#7C3AED', fontSize: 20 }}>→</div>
            </div>
          ))}
        </div>
      ) : (
        // Список подкатегорий
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {subcategories.map(sub => (
            <div
              key={sub}
              onClick={() => handleSubcategoryClick(sub)}
              style={{
                background: 'white',
                borderRadius: 8,
                padding: '14px 16px',
                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: 16,
                fontWeight: 500,
                color: '#1e293b',
              }}
            >
              <span>{sub}</span>
              <span style={{ color: '#7C3AED', fontSize: 18 }}>›</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CategoriesPageMobile;